export const REQUEST_RECOMMENDED_PRODUCTS = 'zola/registry/REQUEST_RECOMMENDED_PRODUCTS';
export const RECEIVED_RECOMMENDED_PRODUCTS = 'zola/registry/RECEIVED_RECOMMENDED_PRODUCTS';
export const REQUEST_RELATED_PRODUCTS = 'zola/registry/REQUEST_RELATED_PRODUCTS';
export const RECEIVED_RELATED_PRODUCTS = 'zola/registry/RECEIVED_RELATED_PRODUCTS';
